import { Link, useNavigate } from "react-router-dom";
import Card from "./Card";
import { DSTRUCTURE } from "./ds";

const DataStructure = () => {
    const navigation = useNavigate();
    return (
        <div>
            <body className="main_container_blogs">
                <header className="header">
                    <nav className="header__menu">
                        <Link className="header__menu__link" to="/">
                            Home
                        </Link>
                        <Link className="header__menu__link" to="/projects">
                            Projects
                        </Link>
                        <Link className="header__menu__link" to="/blogs">
                            Blogs
                        </Link>
                        <div className="dropdown">
                            <Link className="header__menu__link" to="" data-bs-toggle="dropdown" aria-expanded="false">
                                Explore
                            </Link>
                            <ul className="dropdown-menu">
                                <Link className="dropdown-item" to="/ds">
                                    Data Structure
                                </Link>
                            </ul>
                        </div>
                    </nav>
                </header>
                <main className="presentation">
                    <section className="presentation__content">
                        <h1 className="presentation__content__title">BinaryStack Blogs </h1>
                        <div className="card_container">
                            {DSTRUCTURE.data.map((blog) => {
                                return (
                                    <Card
                                        key={blog.ID}
                                        onClick={() => {
                                            navigation(`/ds/${blog.ID}`);
                                        }}
                                    >
                                        <img
                                            src={blog.Image}
                                            alt={blog.Title}
                                            className="presentation__blogs__img"
                                        />
                                        <p className="presentation__blogs__title">{blog.Title}</p>
                                    </Card>
                                );
                            })}
                        </div>
                    </section>
                </main>
            </body>
            <footer className="footer">
                <p>Made by BinaryStack Labs &copy; 2025</p>
            </footer>
        </div>
    );
}

export default DataStructure;